// Blog posts data - in production, this could be fetched from an API or CMS
export const blogPosts = [
  {
    id: 1,
    slug: 'how-to-track-decisions-in-slack',
    title: 'How to Track Decisions in Slack: A Complete Guide',
    date: '2025-06-15',
    excerpt: 'Learn how to effectively track team decisions directly in Slack, keeping all context in one place and ensuring nothing gets lost.',
    keywords: 'slack decision tracking, track decisions slack, slack productivity, team decisions, decision management',
    readTime: '8 min read',
    featuredImage: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=600&fit=crop',
    imageAlt: 'Team collaboration and decision making'
  },
  {
    id: 2,
    slug: 'decision-tracking-best-practices-remote-teams',
    title: 'Decision Tracking Best Practices for Remote Teams',
    date: '2025-03-20',
    excerpt: 'Discover proven strategies for tracking decisions in distributed teams, ensuring transparency and accountability across time zones.',
    keywords: 'remote team decisions, async decision making, distributed teams, remote work productivity',
    readTime: '7 min read',
    featuredImage: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=1200&h=600&fit=crop',
    imageAlt: 'Remote team collaboration'
  },
  {
    id: 3,
    slug: 'slack-productivity-tools-comparison',
    title: '5 Slack Productivity Tools Every Team Should Use',
    date: '2025-09-10',
    excerpt: 'Compare Decision Tracker with other essential Slack productivity tools and learn how to build a complete workflow.',
    keywords: 'slack productivity tools, slack integrations, team productivity, slack apps',
    readTime: '10 min read',
    featuredImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=600&fit=crop',
    imageAlt: 'Productivity and workflow tools'
  },
  {
    id: 4,
    slug: 'why-context-matters-team-decisions',
    title: 'Why Context Matters in Team Decision Making',
    date: '2025-01-15',
    excerpt: 'Explore why maintaining context around decisions is crucial for team success and how Decision Tracker solves this problem.',
    keywords: 'decision context, team decision making, decision documentation, decision tracking',
    readTime: '6 min read',
    featuredImage: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop',
    imageAlt: 'Team meeting and decision making'
  },
  {
    id: 5,
    slug: 'getting-started-decision-tracker-tutorial',
    title: 'Getting Started with Decision Tracker: A Quick Tutorial',
    date: '2025-12-21',
    excerpt: 'Step-by-step guide to setting up Decision Tracker for your Slack workspace and tracking your first decision.',
    keywords: 'decision tracker tutorial, how to use decision tracker, slack bot setup, decision tracking guide',
    readTime: '5 min read',
    featuredImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=600&fit=crop',
    imageAlt: 'Getting started with productivity tools'
  },
  // Free Decision-Making Frameworks
  {
    id: 6,
    slug: 'rapid-decision-framework',
    title: 'Rapid Decision Framework: Make Faster, Better Decisions',
    date: '2025-01-30',
    excerpt: 'Make faster, better decisions with this 4-step framework designed to help teams move from decision paralysis to decisive action.',
    keywords: 'rapid decision making, fast decisions, decision framework, team decision making',
    readTime: '10 min read',
    featuredImage: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=1200&h=600&fit=crop',
    imageAlt: 'Rapid decision making',
    isFramework: true,
    isFree: true
  },
  {
    id: 7,
    slug: 'consensus-building-framework',
    title: 'Consensus Building Framework: Get Everyone on the Same Page',
    date: '2025-01-28',
    excerpt: 'Get everyone on the same page with this 5-stage framework for building consensus and getting buy-in from your entire team.',
    keywords: 'consensus building, team alignment, decision consensus, team buy-in',
    readTime: '12 min read',
    featuredImage: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=1200&h=600&fit=crop',
    imageAlt: 'Consensus building',
    isFramework: true,
    isFree: true
  },
  {
    id: 8,
    slug: 'data-driven-decision-framework',
    title: 'Data-Driven Decision Framework: Let the Numbers Guide You',
    date: '2025-01-26',
    excerpt: 'Let the numbers guide you with this 6-step framework for making evidence-based decisions without analysis paralysis.',
    keywords: 'data-driven decisions, evidence-based decisions, data analysis, decision metrics',
    readTime: '15 min read',
    featuredImage: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&h=600&fit=crop',
    imageAlt: 'Data-driven decisions',
    isFramework: true,
    isFree: true
  },
  {
    id: 14,
    slug: 'free-decision-log-template-notion',
    title: 'Decision Log Template: How to Keep One That Doesn’t Go Stale (Free for Notion)',
    date: '2026-09-15',
    excerpt: 'What to record in a decision log, how to stop it going stale, and when a decision is worth logging. Plus two free Notion templates: a team decision log and architecture decision records.',
    keywords: 'decision log template, notion decision log template, decision register template, ADR template notion, architecture decision record template, decision log, decision register, free notion template',
    readTime: '7 min read',
    featuredImage: 'https://images.unsplash.com/photo-1517842645767-c639042777db?ixlib=rb-4.1.0&w=1200&h=600&fit=crop&auto=format',
    imageAlt: 'Open notebook headed Notes with a fountain pen, ready for a decision log'
  }
];

export const getPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};

export const getAllPosts = () => {
  return blogPosts.sort((a, b) => new Date(b.date) - new Date(a.date));
};




// WEBPACK FOOTER //
// ./src/data/blogPosts.js